// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__AZvE6","avatarSmall":"Avatar_avatarSmall__6Xdd+","avatarLarge":"Avatar_avatarLarge__B7H59"};